import LocalizedStrings from 'react-localization';
export const lang = new LocalizedStrings({
  en: {
    eula: 'EULA',
    pp: 'Privacy Policy',
    support: 'Support',
    uninstall: 'Uninstall',
    addto: 'Add to',
    customize: 'Customize your new tab and enjoy better search results.',
    customize_sub: 'Feel the new tab thrill with Search Administrator Tab.',
    splash_main: 'Search with optimized results powered by Yahoo!',
    splash_main_sub:
      'Enjoy a faster, safer, and better default search experience with Search Administrator.',
    splash_feat: 'Optimize your desktop experience with Search Administrator.',
    splash_feat_sub: 'We have the right products according to your need.',
    products: 'Products',
    sa_default:
      'Search Administrator for Chrome is a default search that offers web, image, video, and shopping results. Now you can search with optimized results powered by Yahoo search.',
    sa_tab:
      'Search Administrator Tab lets you switch easily between your favorite search engines, right from the new tab page. Maximize your new tab page using a personalized dashboard.',
    splash_cta: 'Download all Search Administrator products now!',
    splash_cta_sub: 'Stop your searches from being tracked by the biggest online tracking company.',
    congrats: 'CONGRATULATIONS!',
    activated: 'Search Administrator for Chrome has been activated.',
    welcome:
      'Search Administrator for Chrome is a default search that offers web, image, video, and shopping results. Now you can search with optimized results catered by Yahoo search.',
    oops: 'OOPS',
    not_found: 'The page you requested could not be found',
    back: 'Back to Homepage',
    sup_content:
      "Use the form to submit a new ticket to us and we'll get back to you as soon as possible. If you are telling us about a problem you're having, please include as much information as possible to help us provide an appropriate solution.",
    sup_fullname: 'Please enter your full name',
    sup_email: 'Please enter your email address',
    sup_subject: 'Please enter an appropriate subject for your message',
    sup_message: 'Please enter your message here',
    sup_send: 'SEND',
    sup_error_name: 'Name is required.',
    sup_error_email: 'Valid email is required.',
    sup_error_subject: 'Please input your subject.',
    sup_error_message: 'Please leave us a message.',
    sup_sending: 'Enviando...',
    sup_sent: 'A sua mensagem foi enviada com sucesso!',
    sup_failed: 'Falha ao enviar a mensagem. Por favor, tente novamente.',
    home_title: 'Search Administrator | Enjoy a faster, safer, and better search results.',
    home_desc:
      'Search Administrator - Enjoy a faster, safer, and better default search experience for Chrome and Firefox. Search with optimized results catered by Yahoo search.',
    notfound_title: 'Error | Page Not Found',
    sup_title: 'Search Administrator - Support',
    sup_desc:
      "Search Administrator Support, If you are telling us about a problem you're having, please include as much information as possible to help us provide an appropriate solution..",
  },
  pt: {
    eula: 'EULA',
    pp: 'Política de Privacidade',
    support: 'Suporte',
    uninstall: 'Desinstalar',
    addto: 'Adicionar ao',
    customize: 'Personalize sua nova guia e aproveite os melhores resultados de pesquisa.',
    customize_sub: 'Conheça a nova onda de guias com a Guia do Search Administrator.',
    splash_main: 'Pesquise com resultados otimizados fornecidos pelo Yahoo!',
    splash_main_sub:
      'Desfrute de uma experiência de pesquisa padrão mais rápida, segura e melhor com o Search Administrator.',
    splash_feat: 'Otimize sua experiência desktop com o Search Administrator.',
    splash_feat_sub: 'Nós temos os produtos certos para o que você precisa.',
    products: 'Produtos',
    sa_default:
      'O Search Administrator for Chrome é uma pesquisa-padrão que oferece resultados de páginas da Web, imagens, vídeos e compras. Agora você pode pesquisar com resultados otimizados fornecidos pela pesquisa do Yahoo.',
    sa_tab:
      'A Guia do Search Administrator permite alternar facilmente entre seus motores de pesquisa favoritos, diretamente na página de nova guia. Maximize sua página de nova guia usando um painel personalizado.',
    splash_cta: 'Baixe todos os produtos Search Administrator agora!',
    splash_cta_sub:
      'Impeça que suas pesquisas sejam rastreadas pela maior empresa de rastreamento on-line.',
    congrats: 'PARABÉNS!',
    activated: 'O Search Administrator for Chrome foi ativado.',
    welcome:
      'O Search Administrator for Chrome é uma pesquisa-padrão que oferece resultados de páginas da Web, imagens, vídeos e compras. Agora você pode pesquisar com resultados otimizados selecionados pela pesquisa do Yahoo.',
    oops: 'OPA',
    not_found: 'Não foi possível encontrar a página solicitada',
    back: 'Voltar à Página Inicial',
    sup_content:
      'Use o formulário para nos enviar um novo tíquete, e nós retornaremos o mais rápido possível. Se você está nos informando sobre um problema que está tendo, inclua o máximo de informação possível para nos ajudar a fornecer uma solução apropriada.',
    sup_fullname: 'Por favor digite seu nome completo',
    sup_email: 'Por favor, indique o seu endereço de e-mail.',
    sup_subject: 'Por favor, insira um assunto apropriado para sua mensagem',
    sup_message: 'Por favor, digite sua mensagem aqui',
    sup_send: 'ENVIAR',
    sup_error_name: 'É necessário um nome.',
    sup_error_email: 'É necessário um e-mail válido.',
    sup_error_subject: 'Por favor, digite o seu assunto.',
    sup_error_message: 'Por favor, envie-nos uma mensagem.',
    sup_sending: 'Enviando...',
    sup_sent: 'A sua mensagem foi enviada com sucesso!',
    sup_failed: 'Falha ao enviar a mensagem. Por favor, tente novamente.',
    home_title:
      'Search Administrator | Desfrute de resultados de pesquisa mais rápidos, mais seguros e melhores.',
    home_desc:
      'Search Administrator - Desfrute de uma experiência de pesquisa padrão mais rápida, segura e melhor para o Chrome e Firefox. Pesquise com resultados otimizados fornecidos pela pesquisa do Yahoo.',
    notfound_title: 'Erro | Página Não Encontrada',
    sup_title: 'Search Administrator - Suporte',
    sup_desc:
      'Suporte Search Administrator, se você está nos informando sobre um problema que está enfrentando, forneça o máximo de informações possível para nos auxiliar a fornecer uma solução apropriada.',
  },
});



// WEBPACK FOOTER //
// ./src/lang.js